import React, { useState } from "react";
import SubmitIcon1 from "../../assets/images/submitIcon1.svg";
import AddIcon from "../../assets/images/addicon.svg";
const NotesCard = () => {
  const [notesData, setNotesData] = useState([1, 2, 3]);

  return (
    <div className="flex flex-col w-[424px] h-auto bg-white rounded-[10px] overflow-hidden border border-solid border-[#d2dae1]">
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3">
        <h2 className="font-semibold text-[#203c50] text-lg">Notes</h2>
        <img className="w-[25px] h-[25px]" alt="Fi" src={AddIcon} />
      </div>

      <hr className="w-full h-px" />

      {/* Notes List */}
      <div className="flex flex-col gap-4 px-4 py-2">
        {notesData.map((note, index) => (
          <div key={index} className="flex flex-col bg-gray-100 rounded-lg p-4 shadow-md">
            {/* Note Header */}
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-semibold text-[#2c495d] text-sm">Accounting Assistant...</h3>
                <div className="flex items-center text-xs text-[#f16136] gap-2">
                  <span>Rakesh Sharma</span>
                  <div className="w-px h-4 bg-[#f16136]"></div>
                  <span>22 Aug, 11:30 AM</span>
                </div>
              </div>
              <div className="flex items-center gap-2 border border-[#00000026] rounded-[5px] px-2 py-1">
                <span className="text-xs text-[#2c495d]">Risk</span>
                <div className="w-3 h-3 bg-[#fab143] rounded-full"></div>
              </div>
            </div>

            {/* Note Content */}
            <p className="text-sm text-[#808080] mt-2">
              Lorem Ipsum is a placeholder text commonly used to demonstrate.
            </p>
          </div>
        ))}
      </div>

      {/* Input Section */}
      <div className="flex items-center bg-gray-200 px-4 py-3 gap-2">
        <input
          type="text"
          placeholder="Type something..."
          className="flex-1 bg-transparent outline-none text-xs text-[#808080]"
        />
        <img className="w-5 h-5" alt="Fi" src={SubmitIcon1} />
      </div>
    </div>
  );
};

export default NotesCard;
